
export const preload = function (config) {
  try {
    config.items.forEach((item) => {
      if (item.type === 'tab-pane') {
        preloadTabPaneImg(item);
      }
      if (item.type === 'image') {
        preloadImageCompImg(item);
      }
      if (item.items?.length > 0) {
        preload(item);
      }
    });
  } catch (err) {
    console.err('tabs组件预加载失败了', err);
  }
};
function preloadImageCompImg(item) {
  // 基础组件-图片
  const { envConfigs } = item;
  if (envConfigs?.length > 0) {
    envConfigs.forEach((env) => {
      const { src } = env;
      loadImg(src);
    });
  }
}

function preloadTabPaneImg(item) {
  // tab标题栏
  const { tabTitle } = item;
  if (tabTitle.style) {
    loadImg(tabTitle.style.backgroundImage);
  }
  if (tabTitle.disabledStyle) {
    loadImg(tabTitle.disabledStyle.backgroundImage);
  }
  // tab大容器的背景
  const imgSrc = item.style?.backgroundImage;
  loadImg(imgSrc);
}

function loadImg(src) {
  const img = new Image();
  src && (img.src = src);
}
